import React from 'react';
import { Link } from 'react-router-dom';
import { cafeInfo } from '../data/mock';

const Navbar = () => {
  return (
    <div className="container">
      <nav>
        <Link to="/" style={{ textDecoration: 'none', color: 'var(--primary-orange)', fontSize: '1.8rem', fontWeight: 'bold' }}>
          ☕ {cafeInfo.name}
        </Link>
        <div className="nav-links">
          <Link to="/">Home</Link>
          <Link to="/about">About</Link>
          <a href="#products">Products</a>
          <a href="#location">Location</a>
        </div>
        <a href={cafeInfo.zomatoLink} target="_blank" rel="noreferrer" className="btn-primary">
          Order on Zomato
        </a>
      </nav>
    </div>
  );
};

export default Navbar;